import AppDialog from "components/AppDialog";
import TopUpForm from "pages/dashboard/TopUpForm";
import type {Transaction} from "pages/messaging-account/transactions/api";
import type {Dispatch, FC, SetStateAction} from "react";

type TopUpWalletDialogProps = {
  open: boolean;
  onClose: () => void;
  setData?: Dispatch<SetStateAction<Transaction[] | null>>;
};
const TopUpAccountDialog: FC<TopUpWalletDialogProps> = ({
  open,
  onClose,
  setData,
}) => {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Top Up Wallet"
      description="Fill in the amount you wish to top up."
      maxWidth="sm">
      <TopUpForm onClose={onClose} setData={setData} />
    </AppDialog>
  );
};

export default TopUpAccountDialog;
